const config = {
  locale: 'it-IT', // en-US, zh-CN
}

global.config = config

export default config
